<template>
  <div class="box5">
   <img src="../../../assets/coursePage/trainer/05.png"/>
  </div>
</template>

<script>


export default {
 
  data() {
    return {
 
    };
  },
};
</script>

<style lang="less" scoped>
.box5{
  width: 100%;
 img{
  width: 100%;
  display: block;
 }
  
}
</style>
